@let blok = block();

<div [ngClass]="getOuterClasses()">
  @switch (blok.link?.linktype) {
    @case ('url') {
      <a
        class="disabled:cursor-not-allowed disabled:bg-grey-opacity30 disabled:shadow-md leading-none no-underline"
        [href]="sanitizedLink() | desanitizeSlash"
        [ngClass]="getInnerClasses()"
        [target]="$safeNavigationMigration(blok.link?.target)"
        [rel]="blok.link?.target === '_blank' ? 'noopener noreferrer' : undefined">
        {{ blok.textContent }}
      </a>
    }
    @case ('story') {
      <a
        class="disabled:cursor-not-allowed disabled:bg-grey-opacity30 disabled:shadow-md leading-none no-underline"
        [routerLink]="$safeNavigationMigration(blok.link?.cached_url) | sbRouterLink | cachedUrlResolver"
        [fragment]="$safeNavigationMigration(blok.link?.anchor)"
        [target]="$safeNavigationMigration(blok.link?.target)"
        [ngClass]="getInnerClasses()">
          {{ blok.textContent }}
      </a>
    }
    @case ('email') {
      <a
        class="disabled:cursor-not-allowed disabled:bg-grey-opacity30 disabled:shadow-md leading-none no-underline"
        [href]="'mailto:' + sanitizedLink() | desanitizeSlash"
        [ngClass]="getInnerClasses()">
        {{ blok.textContent }}
      </a>
    }
    @case ('asset') {
      <a
        class="disabled:cursor-not-allowed disabled:bg-grey-opacity30 disabled:shadow-md leading-none no-underline"
        [href]="sanitizedLink() | desanitizeSlash"
        [ngClass]="getInnerClasses()"
        [target]="$safeNavigationMigration(blok.link?.target)">
        {{ blok.textContent }}
      </a>
    }
  }
</div>
